import React from 'react';
import { GoalId, GoalRelatedGoal } from '../../types';
import { GoalAlignedTo } from './GoalAlignedTo';

type Props = {
  goalId: GoalId;
  alignedTo: GoalRelatedGoal[];
  onLinkClick?: () => void;
  onAdd: (goal: GoalRelatedGoal) => Promise<void>;
  onRemove: (goal: GoalRelatedGoal) => Promise<void>;
  isProcessing: boolean;
};

export const GoalAlignedToConnected: React.FC<Props> = ({
  goalId,
  alignedTo,
  onLinkClick,
  onAdd,
  onRemove,
  isProcessing,
}) => {
  if (goalId.type !== 'employee') {
    return null;
  }

  return (
    <GoalAlignedTo
      sourceGoalId={goalId}
      alignedTo={alignedTo}
      onLinkClick={onLinkClick}
      onAdd={onAdd}
      onRemove={onRemove}
      isProcessing={isProcessing}
    />
  );
};
